import ArtifactProvider from '@/components/canvas/CanvasElementSourceProviders/ArtifactProvider';

class HeatmapProvider extends ArtifactProvider {
  constructor(settings) {
    super(settings, 'heatmap');
  }
}

export default HeatmapProvider;
